export default __webpack_public_path__ + "static/media/bg_image2.129b647b.svg";